import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Field, FieldArray } from 'redux-form';
import { t } from '../../../../../modules/infra/i18n';
import Service from './service';
import ResetServicesOrderButton from '../../../services/containers/ResetServicesOrderButton';

class ServicesForm extends Component {
  static renderNoService() {
    return (
      <div className="c-heading c-heading--small">
        {t('barber:form.services.no_services_message')}
      </div>
    );
  }

  static setupServices() {
    return ({ fields, useShopServices }) => {
      if (!fields.length) return ServicesForm.renderNoService();

      const list = fields.map((service, index) => (
        <Field
          name={service}
          serviceName={service}
          component={Service}
          key={index}
          index={index}
        />
      ));

      return (
        <div className="c-table-services c-no-hover" data-automation-id="services">
          <div className="c-table-card__row  c-table-card__head">
            <div className="c-table-card__cell">
              <div className="c-label">{t('barber:form.services.type_header')}</div>
            </div>
            <div className="c-table-card__cell">
              <div className="c-label">{t('barber:form.services.name_header')}</div>
            </div>
            <div className="c-table-card__cell">
              <div className="c-label">{t('barber:form.services.cost_header')}</div>
            </div>
            <div className="c-table-card__cell">
              <div className="c-label">{t('barber:form.services.duration_header')}</div>
            </div>
            <div className="c-table-card__cell">
              <div className="c-label">{useShopServices ? t('barber:form.services.assigned_header') : t('barber:form.services.enabled_header')}</div>
            </div>
            <div className="c-table-card__cell u-text-center">
              <div className="c-label">{t('barber:form.services.default_header')}</div>
            </div>
          </div>
          {list}
        </div>
      );
    };
  }

  constructor(props) {
    super(props);
    this.fieldServices = ServicesForm.setupServices();
  }

  render() {
    const { useShopServices, barberId } = this.props;

    return (
      <div>
        <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb- u-ml">{t('barber:form.services.title')}</div>
        <div className="u-mb- u-ml+" display-if={!!barberId}>
          <ResetServicesOrderButton barber barberId={barberId} />
        </div>
        <div className="c-wrapper-horizontal u-scrollable-x">
          <FieldArray name="services" component={this.fieldServices} useShopServices={useShopServices} />
        </div>
      </div>
    );
  }
}

ServicesForm.propTypes = {
  useShopServices: PropTypes.bool.isRequired,
  barberId: PropTypes.string,
};

ServicesForm.defaultProps = {
  barberId: null,
};

export default ServicesForm;
